const Vue = require('vue')

Vue.component('bus', require('components/Bus.vue'))

const root = new Vue({
    el: '#bus-road',
    template: `<div><bus></bus></div>`
})

module.exports = root



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/bus.js